import { connect } from 'react-redux'
import { IDispatchProps, AppProxy } from './YumGoogleSignIn'
import { doGoogleSignIn } from './store/GoogleSignInActions'

const mapStateToProps = () => ({})

const mapDispatchToProps: IDispatchProps = {
  doGoogleSignIn,
}

export default connect(mapStateToProps, mapDispatchToProps)(AppProxy)
